import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initSystemDesignGrid(): void {
    const cells = document.querySelectorAll('.grid-cell');
    if (cells.length === 0) return;

    gsap.from(cells, {
        opacity: 0,
        scale: 0,
        stagger: {
            grid: [4, 4],
            from: 'center',
            amount: 1.5
        },
        duration: 1,
        ease: 'power2.inOut',
        scrollTrigger: {
            trigger: '.zen-grid',
            start: 'top 80%'
        }
    });
}

export function initC4Modeling(): void {
    const cards = document.querySelectorAll('.c4-card');
    if (cards.length === 0) return;

    gsap.from(cards, {
        opacity: 0,
        y: 50,
        stagger: 0.4,
        duration: 1,
        ease: 'expo.out',
        scrollTrigger: {
            trigger: '.c4-grid',
            start: 'top 70%'
        }
    });
}
